<template>
  <div class="bg-surface-dim mt-3">
    <SoExpansionPanels>
      <SoExpansionPanel
        value="interest-panel"
        bg-color="surface-dim"
        class="w-25"
        no-padding
        @clicked="updateIsOpen($event)"
      >
        <template #title>Customer availability</template>
        <template #alwaysVisible>
          <p class="dropdown-text text-truncate">
            {{ alwaysShownText }}
          </p>
        </template>
        <template #default>
          <p v-for="content in bodyTextContent" :key="content">{{ content }}</p>
          <SoLink
            v-if="isOpen"
            data-testid="edit-availability"
            class="mt-3"
            text="Edit Availability"
            @click="$emit('openModal')"
          />
        </template>
      </SoExpansionPanel>
    </SoExpansionPanels>
  </div>
</template>

<script lang="ts">
  import SoExpansionPanel from "@/components/expansionPanels/SoExpansionPanel.vue"
  import SoExpansionPanels from "@/components/expansionPanels/SoExpansionPanels.vue"
  import SoLink from "@/components/SoLink.vue"
  import { weekDaysShortNames } from "@/constants/general"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import { defineComponent } from "vue"

  export default defineComponent({
    components: {
      SoExpansionPanel,
      SoExpansionPanels,
      SoLink,
    },
    emits: ["openModal"],
    data() {
      return {
        isOpen: false,
        current: useCurrentAccountStore(),
        shortenedNames: weekDaysShortNames,
      }
    },
    computed: {
      interests() {
        return this.current.imbpSmartMeterInterest.data?.interest
      },
      alwaysShownText() {
        return this.isOpen
          ? this.interestsText[0]
          : this.interestsText.join(", ")
      },
      bodyTextContent() {
        return this.interestsText.slice(1)
      },
      interestsText(): Array<string> {
        if (!this.interests) return []
        const entries = Object.entries(this.interests)
        const text: Array<string> = []
        for (const entry of entries) {
          const times: Array<string> = []
          if (entry[1].am) times.push("AM")
          if (entry[1].pm) times.push("PM")

          if (times.length) {
            text.push(`${this.shortenedNames[entry[0]]}: ${times.join(", ")}`)
          }
        }
        return text
      },
    },
    methods: {
      updateIsOpen(val) {
        this.isOpen = val.value
      },
    },
  })
</script>

<style scoped>
  .dropdown-text {
    max-width: 250px;
  }
</style>
